import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import axios from 'axios';

function Test() {
  const { i18n } = useTranslation(); // 3. useTranslation hook 선언
  const langs = ['en', 'ko', 'de'];

  const [value, setValue] = useState('');
  const onChange = e => {
    setValue(e.target.value);
  };

  const onClick = async () => {
    const result = await axios({
      method: 'post',
      url: 'https://server.newseo.me/labatory/nist-unifac',
      data: {
        a: value,
      },
    });
  };

  return (
    // <div className="mx-auto mt-10 w-fit border bg-white p-10">
    //   <div className="flex gap-x-10">
    //     <button onClick={() => i18n.changeLanguage('ko')}>한국어</button>
    //     <button onClick={() => i18n.changeLanguage('en')}>영어</button>
    //     <button onClick={() => i18n.changeLanguage('ja')}>일본어</button>
    //   </div>
    //   <div>{i18n.language}</div>
    // </div>
    <div className="flex items-center justify-center">
      <input className="my-10 w-32 border-2 text-3xl" onChange={onChange} value={value} />
      <button onClick={onClick}>제출</button>
    </div>
  );
}
export default Test;
